// Customers actions
import axios from 'axios';
import types from '../../../types';
/* eslint-disable */
export default {
  [types.GET_INVOICES]: async (context, payload) => {
    try {
      await axios.get(`admin-vendor-invoice/get-list?page=${payload.page}${payload.query}`).then((res) => {
        if (payload.page == 1) {
          context.commit('CLEAR_INVOICES');
          context.commit('STORE_INVOICES', res.data.data);
        } else {
          context.commit('STORE_INVOICES', res.data.data);
        }
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_INVOICE]: async (context, payload) => {
    try {
      await axios.get(`admin-vendor-invoice/get/${payload}`).then((res) => {
        context.commit('STORE_INVOICE', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_INVOICES]: ({ commit }, payload) => {
    commit('STORE_INVOICES', payload);
  },
  [types.CLEAR_INVOICES]: (context) => {
    context.commit('CLEAR_INVOICES');
  },
  [types.CLEAR_INVOICE]: (context) => {
    context.commit('CLEAR_INVOICE');
  },
  [types.DOWNLOAD_VENDOR_INVOICE]: async (context, payload) => {
    try {
      return await axios.get(`/admin-vendor-invoice/download-pdf/${payload}`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
}
